import React from 'react';
import { Link } from 'react-router-dom';
import {
  Drawer,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import WebIcon from '@mui/icons-material/Web';
import AppsIcon from '@mui/icons-material/Apps';
import HomeIcon from '@mui/icons-material/Home';
import LanguageIcon from '@mui/icons-material/Language';
import PrintIcon from '@mui/icons-material/Print';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation';
import HelpIcon from '@mui/icons-material/Help';
import MessageIcon from '@mui/icons-material/Message';
import BrushIcon from '@mui/icons-material/Brush';
import ArticleIcon from '@mui/icons-material/Article';

const navItems = [
  { to: '/home', label: 'Home', icon: <HomeIcon /> },
  { to: '/apps', label: 'Apps', icon: <AppsIcon /> },
  { to: '/websites', label: 'Websites', icon: <WebIcon /> },
  { to: '/logos', label: 'Logos', icon: <LanguageIcon /> },
  { to: '/print', label: 'Print Work', icon: <PrintIcon /> },
  { to: '/animation', label: 'Animation', icon: <OndemandVideoIcon /> },
  { to: '/3d', label: '3D Art', icon: <ThreeDRotationIcon /> },
  { to: '/illustration', label: 'Illustration', icon: <BrushIcon /> },
  { to: '/case-studies', label: 'Case Studies', icon: <ArticleIcon /> },
  { to: '/about', label: 'About', icon: <HelpIcon /> },
  { to: '/contact', label: 'Contact', icon: <MessageIcon /> },
];

export function ButtonAppBar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (isOpen) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setOpen(isOpen);
  };

  return (
    <div style={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            onClick={toggleDrawer(true)}
            edge="start"
            sx={{ mr: 2 }}
            color="inherit"
            aria-label="menu"
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1, fontFamily: 'PerfectDark' }}>
            DraZtic
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        <List>
          {navItems.map((item) => (
            <Link key={item.to} to={item.to} style={{ textDecoration: 'none', color: 'inherit' }}>
              <ListItem button onClick={toggleDrawer(false)}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItem>
            </Link>
          ))}
        </List>
      </Drawer>
    </div>
  );
}
